// Tutorial FEN strings based on the original Unity game board layouts
// Board is 5 columns × 8 rows, FEN shows ranks from bottom (rank 1) to top (rank 8)

import { TutorialPostProcessing } from './TutorialPostProcessing';

export const TUTORIAL_FENS: { [constellation: string]: string[] } = {
  'Bear': [
    '8/8/5B2/8/8', // Solo tutorial: Light Bear only, no opponents
    '8/3BK4/6bk1/8/8',
    '8/4pc2/4BK1gk1/8/8',
    '8/4BK3/8/2M1ck3/3W4',
    '6r1/B6r/BK6rk/B6r/6r1'
  ],
  'Crane': [
    '8/5f2/2CK5/8/7ck',
    '8/8/1CK1t4/7bk/8',
    '6w1/7w/CK6wk/7w/6w1'
  ],
  'Frog': [
    '8/8/5tk2/1FK*6/8',
    '8/2w5/7w/8/2FK*5',
    '8/8/2GK2bf*r/8/1F*6',
    '4t3/M3c3/T3b3/FK3m3/4w3',
    '3c4/2c1c3/5c2/F1c1c3/3c4'
  ],
  'Fungi': [
    '8/8/3UKrk3/8/8',
    '8/3w4/UK3tk3/3s4/8',
    '5s2/7r/UK3w1t1/7c/5b2',
    '8/8/M2uk1b2/8/8',
    '8/UK6m/T6t/M6uk/8',
    '1utmk1/5/5/5/1MTUK1'
  ],
  'Goat': [
    '7w/8/3GK3w/8/7w',
    'GK4s2/1bw1f*2m/8/3ukt3/6r1',
    '5b2/2F*4w/3B1GK2/7r/4c3',
    '4F*3/3S4/2W1wc1g/1R6/MK7'
  ],
  'Monkey': [
    'MKB1B4/6B1/8/8/5T2',
    '8/4T2ck/3MK3r/8/6t1',
    '8/8/3MKb1bk1/8/8',
    '5c2/M3t3/T3b3/UK7/8',
    '8/1B6/6ck1/1MK6/8'
  ],
  'Octopus': [
    '8/8/3Or1MK1/8/8',
    '8/6m1/3O3r/6w1/8',
    '8/3OK3mk/7f/4S2w/8',
    '5m2/8/3uk1O1c/8/5b2',
    '5c2/1F*4m1/1OK4g1/1S4u1/5w2',
    '8/7ok/CK6c/8/8'
  ],
  'Virus': [
    '8/2V1rk1MK1/8/8/8',
    '5c2/8/3s1V2/8/5c2',
    '4G3/4G3/2V1G2bk/4G3/4G3'
  ],
  'Penguin': [
    '8/7wk/5PK2/8/8',
    '8/8/2PKbk/8/8',
    '7b/1bbb3b/3c1b2/1b3b1b/PK6b',
    'M7/7w/7pk/BK6w/8'
  ],
  'Rhino': [
    'T7/5wk2/8/1RKw5/4w3',
    '8/8/CRK2tm2/8/8',
    '8/8/2RKbbCm1/8/8',
    '8/8/M1mkw4/RK7/8',
    'R6b/R6b/RK6bk/R6b/R6b'
  ],
  'Snake': [
    '8/2S2b2/1C6/3c2wk1/8',
    '8/8/8/WSK2m1m1/5wk2',
    '6ck1/4TS2/8/5b1m/1MK3t2',
    ' O4c2/ U2su3/ M4wk2/4f*3/ S7',
    '8/8/8/8/8'
  ],
  'Tree': [
    '3TKc1bk1/8/6BB/8/8', // Tree Tutorial 1: Stone pieces at 7,2 and 6,2
    '3w4/8/CK1T4b/4w1w1/8',
    '7t/2b5/BTK6/5b2/5b2'
  ],
  'Wolf': [
    'C7/4bk3/8/WK7/8',
    'WK2b4/8/6bk1/8/1Tb5',
    '1WK3ct1/2F5/5b1w/8/1m6',
    '6r1/W6r/7rk/W6r/6r1'
  ]
};

// Tutorial post-processing configurations
// Applied after FEN is loaded to modify piece properties
export const TUTORIAL_POST_PROCESSING: { [constellation: string]: { [tutorialIndex: number]: TutorialPostProcessing } } = {
  'Rhino': {
    0: { // Rhino tutorial 1 - Set rhino king hasMoved = true to prevent charge
      modifications: [
        {
          pieceType: 'Rhino',
          side: 'light',
          properties: {
            hasMoved: true
          },
          description: 'Rhino Tutorial 1: Set Rhino King hasMoved = true to disable charge ability'
        }
      ]
    }
  }
  // Add post-processing for other constellations/tutorials as needed
};

export function getTutorialFEN(constellation: string, tutorialIndex: number): string {
  const fens = TUTORIAL_FENS[constellation];
  if (!fens || tutorialIndex < 0 || tutorialIndex >= fens.length) {
    // Default empty board
    return "8/8/8/8/8";
  }
  return fens[tutorialIndex];
}

export function getTutorialPostProcessing(constellation: string, tutorialIndex: number): TutorialPostProcessing | null {
  const constellationConfig = TUTORIAL_POST_PROCESSING[constellation];
  if (!constellationConfig) {
    return null;
  }
  
  const tutorialConfig = constellationConfig[tutorialIndex];
  return tutorialConfig || null;
}